import SolutionBanner from "./views/SolutionBanner";
import SolutionOutstanding from "./views/SolutionOutstanding";
import SolutionDagital from "./views/SolutionDagital";
import HomePackage from "../Home-Page/views/HomePackage";
import CustomersPartners from "../Home-Page/views/CustomersPartners";
import Advise from "../Home-Page/views/Advise";
import CusPart from "../Home-Page/views/CuPart";
import SolutionSuitable from "./views/SolutionSuitable";

export default function Solution() {
  return (
    <div className="pt-[71px] w-full">
      <SolutionBanner />
      <div id="outl">
        <SolutionOutstanding />
      </div>
      <SolutionDagital />
      <SolutionSuitable />
      <div className="mt-10">
        <HomePackage />
      </div>
      {/* <CustomersPartners /> */}
      <CusPart />
      <div id="advise">
        <Advise />
      </div>
    </div>
  );
}
